// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"stackBookCover__wrapper","image":"stackBookCover__image","audioBook":"stackBookCover__audioBook"};